import { nanoid } from "nanoid";

import type { ObservationsMapParameterDisplayGroup } from "@/lib/api";

/** CMS form entry: API shape plus client-only id for stable DnD/popover anchoring. */
export type ObservationsMapDisplayGroupFormEntry = ObservationsMapParameterDisplayGroup & {
  id: string;
};

export function createDisplayGroupFormId(): string {
  return nanoid();
}

export function ensureDisplayGroupFormIds(
  groups: Array<
    Partial<ObservationsMapDisplayGroupFormEntry> &
      Pick<ObservationsMapParameterDisplayGroup, "parameter_ids">
  >,
): ObservationsMapDisplayGroupFormEntry[] {
  return groups.map((group) => ({
    label_override: group.label_override ?? null,
    parameter_ids: [...group.parameter_ids],
    id: group.id ?? createDisplayGroupFormId(),
  }));
}

export function displayGroupsNeedFormIds(
  groups: Array<ObservationsMapParameterDisplayGroup & { id?: string }> | undefined,
): boolean {
  return (
    Array.isArray(groups) &&
    groups.some((group) => typeof group.id !== "string" || !group.id)
  );
}

export function findDisplayGroupFormIndex(
  groups: ObservationsMapDisplayGroupFormEntry[],
  groupId: string,
): number {
  return groups.findIndex((group) => group.id === groupId);
}
